/**
 * Client link route helper.
 *
 * Checks whether a given pathname belongs to the client link route space
 * (/client/<token>). Kept as a pure function with no external/Firebase imports
 * so it can be safely used anywhere (routing, bootstrapping, top-level checks).
 */

export const isClientLinkPath = (pathname: string | null | undefined): boolean => {
  if (!pathname || typeof pathname !== 'string') return false
  return pathname.startsWith('/client/') && pathname.length > '/client/'.length
}

export const extractClientLinkToken = (pathname: string | null | undefined): string | null => {
  if (!isClientLinkPath(pathname)) return null
  const segment = (pathname as string).slice('/client/'.length).split('/')[0]
  return segment || null
}
